import React, { useState } from 'react';
import CalendlyButton from './CalendlyButton';
import './Experience.css';

// Import data from sidebar components
const techCategories = [
  {
    header: 'Category 1',
    items: [
      // Content to be filled in later
    ]
  },
  {
    header: 'Category 2',
    items: [
      // Content to be filled in later
    ]
  }
];

const softSkillsCategories = [
  {
    header: 'Category 1',
    items: [
      // Content to be filled in later
    ]
  }
];

const resumeSections = [
  { id: 'objective', title: 'Objective', icon: '🎯' },
  { id: 'summary', title: 'Professional Summary', icon: '📋' },
  { id: 'competencies', title: 'Core Competencies', icon: '⭐' },
  { id: 'techskills', title: 'Technical Skills', icon: '⚙️' },
  { id: 'experience', title: 'Experience', icon: '💼' },
  { id: 'certifications', title: 'Certifications', icon: '🏆' },
  { id: 'education', title: 'Education', icon: '🎓' },
  { id: 'hobbies', title: 'Hobbies', icon: '🎨' },
  { id: 'activities', title: 'Activities / Memberships / Awards', icon: '🏅' },
  { id: 'technologies', title: 'Technologies & Tools', icon: '⚙️' },
  { id: 'softskills', title: 'Soft Skills', icon: '🤝' },
  { id: 'references', title: 'References', icon: '📞' },
];

const Experience = () => {
  const [expandedSections, setExpandedSections] = useState({
    objective: true,
    summary: false,
    competencies: false,
    techskills: false,
    experience: false,
    certifications: false,
    education: false,
    hobbies: false,
    activities: false,
    technologies: false,
    softskills: false,
    references: false,
  });

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const recentExperience = [
    // Content to be filled in later
  ];

  const olderExperience = [
    // Content to be filled in later
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <div className="section-header">
            <h2 className="section-title">Resume</h2>
            <p className="section-subtitle">
              Content to be filled in later
            </p>
          </div>

          <div className="resume-sections">
            {resumeSections.map(section => (
              <div key={section.id} className="resume-section">
                <div className="resume-section-header" onClick={() => toggleSection(section.id)}>
                  <div className="resume-section-title">
                    <span className="resume-section-icon">{section.icon}</span>
                    <h3>{section.title}</h3>
                  </div>
                  <button className={`expand-btn ${expandedSections[section.id] ? 'expanded' : ''}`}>
                    {expandedSections[section.id] ? '−' : '+'}
                  </button>
                </div>
                {expandedSections[section.id] && (
                  <div className="resume-section-content">
                    {section.id === 'objective' ? (
                      <div>
                        Content to be filled in later
                      </div>
                    ) : section.id === 'summary' ? (
                      <div>
                        Content to be filled in later
                      </div>
                    ) : section.id === 'competencies' ? (
                      <ul style={{margin:0,paddingLeft:'1.2em'}}>
                        <li>Content to be filled in later</li>
                      </ul>
                    ) : section.id === 'techskills' ? (
                      <div>
                        Content to be filled in later
                      </div>
                    ) : section.id === 'certifications' ? (
                      <ul style={{margin:0,paddingLeft:'1.2em'}}>
                        <li>Content to be filled in later</li>
                      </ul>
                    ) : section.id === 'education' ? (
                      <div>
                        Content to be filled in later
                      </div>
                    ) : section.id === 'hobbies' ? (
                      <div>
                        Content to be filled in later
                      </div>
                    ) : section.id === 'activities' ? (
                      <ul style={{margin:0,paddingLeft:'1.2em'}}>
                        <li>Content to be filled in later</li>
                      </ul>
                    ) : section.id === 'technologies' ? (
                      <div>
                        {techCategories.map(cat => (
                          <div key={cat.header} style={{marginBottom: '1.5rem'}}>
                            <h4 style={{color: '#008B8B', marginBottom: '0.75rem', fontSize: '1.1rem'}}>{cat.header}</h4>
                            <ul style={{margin: 0, paddingLeft: '1.2em'}}>
                              {cat.items.length > 0 ? (
                                cat.items.map(item => (
                                  <li key={item}>{item}</li>
                                ))
                              ) : (
                                <li>Content to be filled in later</li>
                              )}
                            </ul>
                          </div>
                        ))}
                      </div>
                    ) : section.id === 'softskills' ? (
                      <div>
                        {softSkillsCategories.map(cat => (
                          <div key={cat.header} style={{marginBottom: '1.5rem'}}>
                            <h4 style={{color: '#008B8B', marginBottom: '0.75rem', fontSize: '1.1rem'}}>{cat.header}</h4>
                            <ul style={{margin: 0, paddingLeft: '1.2em'}}>
                              {cat.items.length > 0 ? (
                                cat.items.map(item => (
                                  <li key={item}>{item}</li>
                                ))
                              ) : (
                                <li>Content to be filled in later</li>
                              )}
                            </ul>
                          </div>
                        ))}
                      </div>
                    ) : section.id === 'references' ? (
                      <div>Available upon request</div>
                    ) : section.id === 'experience' ? (
                      <>
                        {/* Recent Experience */}
                        <div className="experience-section">
                          <h4 className="experience-section-title">Recent Experience</h4>
                          <div className="experience-cards">
                            {recentExperience.length > 0 ? (
                              recentExperience.map((job) => (
                                <div key={job.id} className="experience-card">
                                  <div className="experience-header">
                                    <div className="experience-title">
                                      <h3>{job.title}</h3>
                                      <p className="company-name">{job.company}</p>
                                      <p className="period">{job.period}</p>
                                    </div>
                                    <button
                                      className={`expand-btn ${expandedSections[job.id] ? 'expanded' : ''}`}
                                      onClick={() => toggleSection(job.id)}
                                    >
                                      {expandedSections[job.id] ? '−' : '+'}
                                    </button>
                                  </div>
                                  {expandedSections[job.id] && (
                                    <div className="experience-details">
                                      <ul className="achievements-list">
                                        {job.achievements.map((achievement, index) => (
                                          <li key={index}>{achievement}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              ))
                            ) : (
                              <p style={{ textAlign: 'center', color: '#e8e8e8', padding: '2rem' }}>
                                Content to be filled in later
                              </p>
                            )}
                          </div>
                        </div>
                        {/* Older Experience */}
                        <div className="experience-section">
                          <h4 className="experience-section-title">Earlier Experience</h4>
                          <div className="experience-cards">
                            {olderExperience.length > 0 ? (
                              olderExperience.map((job) => (
                                <div key={job.id} className="experience-card">
                                  <div className="experience-header">
                                    <div className="experience-title">
                                      <h3>{job.title}</h3>
                                      <p className="company-name">{job.company}</p>
                                      <p className="period">{job.period}</p>
                                    </div>
                                    <button
                                      className={`expand-btn ${expandedSections[job.id] ? 'expanded' : ''}`}
                                      onClick={() => toggleSection(job.id)}
                                    >
                                      {expandedSections[job.id] ? '−' : '+'}
                                    </button>
                                  </div>
                                  {expandedSections[job.id] && (
                                    <div className="experience-details">
                                      <ul className="achievements-list">
                                        {job.achievements.map((achievement, index) => (
                                          <li key={index}>{achievement}</li>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              ))
                            ) : (
                              <p style={{ textAlign: 'center', color: '#e8e8e8', padding: '2rem' }}>
                                Content to be filled in later
                              </p>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="resume-placeholder">(Content coming soon)</div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <div className="calendly-button-section">
            <CalendlyButton />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;

